export default
{
    components:
    {

    },

    props:
    {
        activeIndex: { type: Number, default: 0 },
        content: { type: Object, default: null }
    },

    watch:
    {
        activeIndex: 'onActiveIndexChange'
    },

    data()
    {
        return {
            isTrackerGrabbing: false,
            isListGrabbing: false,

            scrollTracker: 0,
            scrollList: 0,

            scrollRatio: 0,
            hasScrollBar: false
        }
    },

    created()
    {
        this._tracker = {
            start: 0,
            end: 0,
            curr: 0
        }

        this._list = {
            start: 0,
            end: 0,
            curr: 0
        }

        this._currX = 0
        this._endX = 0

        this.eventHub.$on('window:resize', this.onResize)
        this.eventHub.$on('window:tick', this.onTick)
    },

    mounted()
    {
        this.$list = this.$el.querySelector('.js-list')
        this.$tracker = this.$el.querySelector('.js-tracker')
        this.$items = this.$el.querySelectorAll('.js-item-pagination')

        this.onResize()
    },

    destroyed()
    {
        this.eventHub.$off('window:resize', this.onResize)
        this.eventHub.$off('window:tick', this.onTick)
    },

    methods:
    {
        onResize()
        {
            this._listWidth = this.$list.offsetWidth

            this.hasScrollBar = this._listWidth > this.$root.window.width
        },

        onActiveIndexChange()
        {
            const w = this.$root.isSmallScreen ? 140 : 180
            this._list.curr = (w * this.activeIndex * -1) + (this.$root.window.width * .5 - 90)
            this._tracker.curr = (this._list.curr / (this._listWidth - this.$root.window.width)) * -1 * (this.$root.window.width - 52 - 82)

            this.$list.style.transitionDuration = '1s'
            this.$tracker.style.transitionDuration = '1s'
        },

        onTrackerDown(event)
        {
            const x = event.pageX || event.touches[0].pageX

            this.isTrackerGrabbing = true

            this._tracker.end = this._tracker.curr
            this._list.end = this._list.curr

            this._tracker.start = x - this._tracker.end

            this.$list.style.transitionDuration = '1s'
            this.$tracker.style.transitionDuration = '0s'
        },

        onTrackerUp(event)
        {
            this.isTrackerGrabbing = false
        },

        onMouseMove(event)
        {
            const x = event.pageX || event.touches[0].pageX

            if(this.isListGrabbing)
            {
                this._list.curr = x - this._list.start

                this._tracker.curr = (this._list.curr / (this._listWidth - this.$root.window.width)) * -1 * (this.$root.window.width - 52 - 82)
            }

            if(this.isTrackerGrabbing)
            {
                this._tracker.curr = x - this._tracker.start

                this._list.curr = (this._tracker.curr / (this.$root.window.width - 52 - 82)) * -1 * (this._listWidth - this.$root.window.width)
            }
        },

        onListDown(event)
        {
            const x = event.pageX || event.touches[0].pageX

            this.isListGrabbing = true
            this.$el.classList.add('is-list-grabbing')

            this._tracker.end = this._tracker.curr
            this._list.end = this._list.curr

            this._list.start = x - this._list.end

            this.$list.style.transitionDuration = '0s'
            this.$tracker.style.transitionDuration = '1s'
        },

        onListUp(event)
        {
            this.$el.classList.remove('is-list-grabbing')
            this.isListGrabbing = false
        },

        onItemDown(event)
        {
            this._itemStartX = event.pageX || event.touches[0].pageX
        },

        onItemUp(event, index)
        {
            const x = event.pageX || event.touches[0].pageX

            if(Math.abs(x - this._itemStartX) < 10)
            {
                this.activeIndex = index
                this.$emit('item:click', this.activeIndex)
            }
        },

        onClick(event)
        {
            const x = event.pageX || event.touches[0].pageX

            this._tracker.curr = x - 26 - 41
            this._list.curr = (this._tracker.curr / (this.$root.window.width - 52 - 82)) * -1 * (this._listWidth - this.$root.window.width)

            this.$list.style.transitionDuration = '1s'
            this.$tracker.style.transitionDuration = '1s'
        },

        scrollBy(ratio)
        {
            this._list.curr += 100 * ratio * -1
            this._tracker.curr = (this._list.curr / (this._listWidth - this.$root.window.width)) * -1 * (this.$root.window.width - 52 - 82)

            this.$tracker.style.transitionDuration = '1s'
            this.$list.style.transitionDuration = '1s'
        },

        onTick()
        {
            if(!this.hasScrollBar)
            {
                return
            }

            if(this._list.curr > 0)
            {
                this._list.curr = 0
            }
            else if(this._list.curr * -1 > this._listWidth - this.$root.window.width)
            {
                this._list.curr = (this._listWidth - this.$root.window.width) * -1
            }

            if(this._tracker.curr < 0)
            {
                this._tracker.curr = 0
            }
            else if(this._tracker.curr > this.$root.window.width - 52 - 82)
            {
                this._tracker.curr = this.$root.window.width - 52 - 82
            }

            this.$list.style.transform = 'translateX(' + this._list.curr + 'px) translateZ(0)'

            this.$tracker.style.transform = 'translateX(' + this._tracker.curr + 'px) translateZ(0)'

        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-encyclopedia-pagination/script.js